import reduce from 'lodash/reduce';
import i18next from '../../../../shared/translations/i18n';
import {
    getDataByLanguage,
    loadCustomLabelTranslations,
} from '../../../../shared/translations/i18nUtils';

const TRANSLATION_KEY_REGEX = 'key:[^\\"]+';

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(`"${find}"`, 'g'), `"${replace}"`);
}

export function warnMissedTranslations(
    stringConfig,
    currentLanguage = i18next.language
) {
    const missedTranslations = stringConfig.match(
        new RegExp(TRANSLATION_KEY_REGEX, 'g')
    );

    if (missedTranslations) {
        // eslint-disable-next-line no-console
        console.error(
            `Translations missing for language <${currentLanguage}>: ${missedTranslations}`
        );
    }

    return missedTranslations;
}

export function replaceAllCustomLabels(config, customLabels) {
    const stringifiedConfig = JSON.stringify(config);

    const modifiedConfig = reduce(
        customLabels,
        (result, value, key) => replaceAll(result, key, value),
        stringifiedConfig
    );

    warnMissedTranslations(modifiedConfig);

    return JSON.parse(modifiedConfig);
}

/* eslint-disable complexity */
export function addTranslatableViewKeyProperty(configuration) {
    return {
        ...configuration,
        views: configuration.views.map((view) => {
            if (view.viewLabel) {
                return view;
            }

            const viewLabel =
                view.viewKey && configuration.views.length > 1
                    ? `key:${view.viewKey}`
                    : undefined;

            return {
                ...view,
                viewLabel,
            };
        }),
    };
}
/* eslint-enable complexity */

export function applyTranslationTransformations(configuration, customLabels) {
    return replaceAllCustomLabels(
        addTranslatableViewKeyProperty(configuration),
        customLabels
    );
}

export function applyFeaturesTransformations(configuration) {
    return {
        ...configuration,
        views: configuration.views.map((view) => {
            const { isDownloadable } = view;

            if (isDownloadable === false) {
                return {
                    ...view,
                    features: {
                        showPortraitPrint: false,
                        showLandscapePrint: false,
                    },
                };
            }

            return {
                ...view,
            };
        }),
    };
}

export function v2ConfigMapper(config) {
    const { version, translations, ...configuration } = config;

    if (!translations) {
        throw Error('v2 configuration missing `translations` property');
    }

    loadCustomLabelTranslations(translations);
    const { customLabels } = getDataByLanguage(i18next.language);

    const configWithTranslationTransformations =
        applyTranslationTransformations(configuration, customLabels);

    const configWithFeaturesTransformations = applyFeaturesTransformations(
        configWithTranslationTransformations
    );

    return configWithFeaturesTransformations;
}
